import { createAction } from 'redux-actions';

export const toggleSidebarNav = createAction('REPORTS_TOGGLE_SIDEBAR_NAV');

export const toggleDropdownNavItem = createAction(
  'REPORTS_TOGGLE_DROPDOWN_NAV_ITEM'
);

export const resetDropdownNavItems = createAction(
  'REPORTS_RESET_DROPDOWN_NAV_ITEMS'
);
